import {Component, Input, Output, EventEmitter} from '@angular/core';


@Component({
  selector: 'ui-collapse',
  standalone: true,
  imports: [],
  templateUrl: './ui-collapse.component.html',
  styleUrl: './ui-collapse.component.scss'
})
export class UiCollapseComponent {
  @Input() isOpen: boolean = false;
  @Input() title: string = '';
  @Input() icon: 'arrow' | 'plus' | 'none' = 'arrow';
  @Input() bordered: boolean = false;
  @Output() isOpenChange = new EventEmitter<boolean>();

  get collapseClasses(): string {
    const classes = ['collapse'];

    if (this.icon === 'arrow') {
      classes.push('collapse-arrow');
    } else if (this.icon === 'plus') {
      classes.push('collapse-plus');
    }

    if (this.bordered) {
      classes.push('border', 'border-base-300');
    }

    return classes.join(' ');
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
  }
}


